// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.week-header .react-datepicker {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.month-side-info .view-header .month-header .header-buttons,
.month-side-info .view-header .week-header .header-buttons,
.week-side-info .view-header .month-header .header-buttons,
.week-side-info .view-header .week-header .header-buttons {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.month-side-info .view-header .month-header .header-buttons .btn,
.month-side-info .view-header .week-header .header-buttons .btn,
.week-side-info .view-header .month-header .header-buttons .btn,
.week-side-info .view-header .week-header .header-buttons .btn {
  min-width: 3.5rem;
  flex: 1 0 3.5rem;
  font-size: 0.8rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0.2rem;
}
.month-side-info .view-header .month-header .header-buttons .btn + .btn,
.month-side-info .view-header .week-header .header-buttons .btn + .btn,
.week-side-info .view-header .month-header .header-buttons .btn + .btn,
.week-side-info .view-header .week-header .header-buttons .btn + .btn {
  margin-left: 0.2vw;
}
@media (min-width: 1441px) {
  .month-side-info .view-header .month-header .header-buttons .btn,
  .month-side-info .view-header .week-header .header-buttons .btn,
  .week-side-info .view-header .month-header .header-buttons .btn,
  .week-side-info .view-header .week-header .header-buttons .btn {
    font-size: 1rem;
  }
  .month-side-info .view-header .month-header .header-buttons .btn + .btn,
  .month-side-info .view-header .week-header .header-buttons .btn + .btn,
  .week-side-info .view-header .month-header .header-buttons .btn + .btn,
  .week-side-info .view-header .week-header .header-buttons .btn + .btn {
    margin-left: 0.3vw;
  }
  .month-side-info .view-header .month-header .header-buttons .btn.small-screen,
  .month-side-info .view-header .week-header .header-buttons .btn.small-screen,
  .week-side-info .view-header .month-header .header-buttons .btn.small-screen,
  .week-side-info .view-header .week-header .header-buttons .btn.small-screen {
    display: none;
  }
}
@media (max-width: 1441px) {
  .month-side-info .view-header .month-header .header-buttons .btn.large-screen,
  .month-side-info .view-header .week-header .header-buttons .btn.large-screen,
  .week-side-info .view-header .month-header .header-buttons .btn.large-screen,
  .week-side-info .view-header .week-header .header-buttons .btn.large-screen {
    display: none;
  }
}
.month-side-info .react-datepicker__header,
.week-side-info .react-datepicker__header {
  margin: 0;
  width: 100%;
}

.view-header .month-header .open-date-picker .react-datepicker .react-datepicker__day--highlighted:after {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Calendar/ViewHeader/ViewHeader.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;AAEF;;AAMM;;;;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAAR;AAEQ;;;;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;AAGV;AADU;;;;EACE,kBAAA;AAMZ;AAHU;EAbF;;;;IAcI,eAAA;EASV;EAPU;;;;IACE,kBAAA;EAYZ;EATU;;;;IACE,aAAA;EAcZ;AACF;AAXU;EACE;;;;IACE,aAAA;EAgBZ;AACF;AARI;;EACE,SAAA;EACA,WAAA;AAWN;;AALE;EACE,6BAAA;AAQJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n\n.week-header .react-datepicker {\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.month-side-info,\n.week-side-info {\n  .view-header {\n    .month-header,\n    .week-header {\n      .header-buttons {\n        display: flex;\n        flex-flow: row wrap;\n        justify-content: space-between;\n\n        .btn {\n          min-width: 3.5rem;\n          flex: 1 0 3.5rem;\n          font-size: 0.8rem;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          margin-bottom: 0.2rem;\n\n          & + .btn {\n            margin-left: 0.2vw;\n          }\n\n          @media (min-width: $desktop) {\n            font-size: 1rem;\n\n            & + .btn {\n              margin-left: 0.3vw;\n            }\n\n            &.small-screen {\n              display: none;\n            }\n          }\n\n          @media (max-width: $desktop) {\n            &.large-screen {\n              display: none;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .react-datepicker {\n    &__header {\n      margin: 0;\n      width: 100%;\n    }\n  }\n}\n\n.view-header {\n  .month-header .open-date-picker .react-datepicker .react-datepicker__day--highlighted:after {\n    background-color: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
